<!--
  记录列表
  lovi 2020-06-02
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('wallet.billDetail')"
      :fixed="true"
      left-arrow
      @click-left="back"
    />


    <vue-filter
      :list="filterList"
      :countflag="true"
      :countData="filterCount"
      @getFilterData="getFilterData"
    />

    <div
      class="content-wrapper"
      :class="{ noCrad: !listData.length && getListFlag }"
    >
      <div v-if="!listData.length && getListFlag" class="noCard-wrap">
        <img src="@/assets/images/public/pic_kong@2x.png" />
        <p class="text-gray">{{ $t("common.noData") }}</p>
      </div>
      <scroll
        v-if="listData.length && getListFlag"
        ref="scroll"
        :data="listData"
        :pullUpLoad="true"
        :pullDownRefresh="true"
        @pullingDown="pullingDown"
        @pullingUp="pullingUp"
      >
        <ul class="record-list">
          <li
            v-for="(item, index) in listData"
            :key="index"
            @click="toDetail(item)"
          >
            <img class="li-img"  :src="
                item.icon
                  ? httpUrl + item.icon
                  : require('@/assets/images/public/logo_icon@2x.png')
              " />
            <div class="li-info">
              <div class="info-l">
                <h3>{{ item.type_name }}</h3>
                <p class="text-gray">{{ item.createtime }}</p>
              </div>
              <div class="info-r">
                <p class="text-blue">
                  {{ item.status }}
                </p>
                <h4>{{ item.money }}</h4>
              </div>
            </div>
          </li>
        </ul>
      </scroll>
    </div>

    <tabbar />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Tabbar from "./tabbar";
import VueFilter from "@/components/filter";
export default {
  name: "bill",
  meta: {
    keepAlive: true
  },
  components: {
    VueFilter,
    Tabbar
  },
  data() {
    return {
      filterList: [],
      filterCount: [
        {
          label: this.$t("common.totalIncome"),
          value: "0.00"
        },
        {
          label: this.$t("common.totalExpenditure"),
          value: "0.00"
        }
      ],
      allTotal: 0, //总支出
      startDate: this._formatDate(new Date()),
      endDate: this._formatDate(new Date()),
      page: 1,
      type: "",
      pay_type: "",
      listData: [],
      getListFlag: false,

      pullUpLoadFlag: false
    };
  },
  created() {
    this.billDetailsType();
    this.getMyAccountLog();
  },
  mounted() {},
  computed: {
    ...mapGetters(["backFlag"])
  },
  methods: {
    billDetailsType() {
      // 账单明细类型
      let vm = this;
      vm.$post("/app/help/billDetailsType", {}, { loading: true }).then(res => {
        console.log("billDetailsType", res);
        vm.filterList = [];
        let obj1 = {};
        obj1.title = vm.$t("wallet.quickScreen");
        obj1.list = res.list;
        vm.filterList.push(obj1);
        let obj2 = {};
        obj2.title = vm.$t("wallet.transactionType");
        obj2.list = res.pay_type;
        vm.filterList.push(obj2);
        vm.type = vm.filterList[0].list[0].key;
        vm.pay_type = vm.filterList[1].list[0].key;
        console.log("filterList", vm.filterList);
      });
    },
    getFilterData(data) {
      // 获取筛选数据
      let vm = this;
      vm.startDate = data.startDate;
      vm.endDate = data.endDate;
      vm.type = data.filterList[0].key;
      vm.pay_type = data.filterList[1].key;
      vm.page = 1;
      vm.getMyAccountLog();
    },
    pullingDown() {
      let vm = this;
      vm.page = 1;
      vm.getMyAccountLog();
    },
    pullingUp() {
      let vm = this;
      if (vm.pullUpLoadFlag) {
        vm.$refs.scroll.forceUpdate(false);
        return;
      }
      vm.page += 1;
      vm.getMyAccountLog(1);
    },
    getMyAccountLog(flag) {
      // 账单明细
      let vm = this;
      let params = {};
      params.start_date = vm.startDate;
      params.end_date = vm.endDate;
      params.type = vm.type;
      params.pay_type = vm.pay_type;
      params.page = vm.page;
      let loading = true;
      vm.getListFlag = false;
      if (flag) {
        loading = false;
        vm.getListFlag = true;
      }
      vm.$post("/app/order/getMyAccountLog", params, { loading: loading }).then(
        res => {
          console.log("getMyAccountLog", res);
          vm.getListFlag = true;
          vm.filterCount=[
            {
              label: this.$t("common.totalIncome"),
              value: res.total_revenue
            },
            {
              label: this.$t("common.totalExpenditure"),
              value: res.total_spend
            }
          ];
          if (vm.page == 1) {
            vm.listData = res.list;
          } else {
            vm.listData = vm.listData.concat(res.list);
          }
          if (res.list.length < 10) {
            vm.pullUpLoadFlag = true;
          } else {
            vm.pullUpLoadFlag = false;
          }
        }
      );
    },
    toDetail(data) {
      //跳转详情
      let vm = this;
      vm.$router.push({
        path: "/detail",
        name: "detail",
        query: { flag: data.type, order_id: data.order_id }
      });
    },
    back()
    {
      let vm = this;
      vm.$router.push({
        path: "/wallet",
        name: "wallet",
      });
    }

  },
  watch: {},
  beforeRouteLeave(to, from, next) {
    this._vnodeKeepAlive(to, from, next, this.$vnode, "statistics");
  }
};
</script>

<style lang="less" scoped>
.content-wrapper {
  top: 44px + 50px + 38px !important;
  bottom: 51px !important;
}

.record-list {
  background: #fff;
  padding: 0 15px;
  li {
    padding: 10px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1.1px solid #e4e4e4;
    .li-img {
      flex: 0 0 32px;
      margin-right: 10px;
      width: 32px;
      height: 32px;
    }
    .li-info {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3,
      h4,
      p {
        line-height: 1.2;
      }
      h3 {
        font-size: 16px;
        font-weight: 400;
      }
      h4 {
        font-size: 16px;
        font-weight: 400;
        color: #333;
      }
      p {
        font-size: 12px;
      }
      .info-l {
        flex: 1;
        p {
          margin-top: 4px;
        }
      }
      .info-r {
        text-align: right;
        p {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
